import { TmBaseComponent } from '@treasury/presentation';
import { plusIcon } from '@treasury/presentation/assets/icons';
import '@treasury/presentation/components/tm-button';
import '@treasury/presentation/components/tm-context-menu';
import '@treasury/presentation/components/tm-icon';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';

export const tagName = 'add-accounts-to-group-menu';

@customElement(tagName)
export class AddAccountsToGroupMenu extends TmBaseComponent {
    protected render() {
        return html`<tm-context-menu
            .openOn=${'click'}
            .closeOn=${'addAccounts'}
            .items=${[{ text: 'Add accounts' }]}
            @item-selected=${(e: CustomEvent) => {
                this.dispatchEvent(new CustomEvent('addAccounts', { detail: e.detail }));
            }}
            ><tm-button importance="tertiary"
                ><tm-icon .icon=${plusIcon} color="#fff"></tm-icon></tm-button
        ></tm-context-menu>`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: AddAccountsToGroupMenu;
    }
}
